// src/pages/AddUnit.jsx

import { useState, useEffect } from "react";
import axios from '../../axios';
import API_BASE_URL from "../../config";
import { useNavigate } from "react-router-dom";

export default function AddUnit() {
  const navigate = useNavigate();
  const companyId = parseInt(localStorage.getItem("companyId"), 10);

  const [formData, setFormData] = useState({ nameAr: "", nameEn: "" });
  const [units, setUnits]     = useState([]);
  const [loading, setLoading] = useState(false);

  // جلب الوحدات عند التحميل وبعد كل تغيير
  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/Unit/by-company/${companyId}`
      );
      setUnits(res.data);
    } catch (err) {
      console.error("❌ خطأ تحميل الوحدات:", err);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/Unit`, {
        ...formData,
        companyId
      });
      alert("✅ تم إضافة الوحدة بنجاح");
      setFormData({ nameAr: "", nameEn: "" });
      fetchUnits();
    } catch (err) {
      console.error("❌ حدث خطأ أثناء الحفظ:", err.response?.data || err);
      alert(err.response?.data?.message || "❌ حدث خطأ أثناء الحفظ");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async id => {
    if (!window.confirm("❗ هل تريد تعطيل هذه الوحدة؟")) return;
    try {
      await axios.delete(`${API_BASE_URL}/api/Unit/${id}`);
      fetchUnits();
    } catch (err) {
      console.error("❌ خطأ عند الحذف:", err);
      alert("❌ حدث خطأ أثناء الحذف");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4" dir="rtl">
      <div className="max-w-3xl mx-auto space-y-6">
        {/* إضافة وحدة */}
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-lg shadow-lg space-y-6"
        >
          <h2 className="text-2xl font-bold text-blue-700 text-center">
            ⚖️ إضافة وحدة
          </h2>

          <div>
            <label className="block text-sm mb-1">الاسم العربي</label>
            <input
              name="nameAr"
              value={formData.nameAr}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
              required
            />
          </div>

          <div>
            <label className="block text-sm mb-1">الاسم الإنجليزي</label>
            <input
              name="nameEn"
              value={formData.nameEn}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded text-lg disabled:opacity-50"
          >
            {loading ? "جاري الحفظ..." : "💾 حفظ"}
          </button>
        </form>

        {/* جدول الوحدات */}
        <div className="bg-white p-4 rounded-lg shadow-lg overflow-x-auto">
          <h3 className="text-xl font-semibold mb-4">📋 قائمة الوحدات</h3>
          <table className="min-w-full table-auto border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100 text-center">
                {["#", "الاسم (عربي)", "الاسم (انجليزي)", "الكود", "حالة التفعيل", "الإجراءات"].map((h, i) => (
                  <th key={i} className="px-4 py-2 border">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {units.map((u, idx) => (
                <tr key={u.id} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="px-4 py-2 border text-center">{idx + 1}</td>
                  <td className="px-4 py-2 border">{u.nameAr}</td>
                  <td className="px-4 py-2 border">{u.nameEn || "-"}</td>
                  <td className="px-4 py-2 border text-center">{u.code}</td>
                  <td className="px-4 py-2 border text-center">
                    {u.isActive ? "مفعل" : "معطل"}
                  </td>
                  <td className="px-4 py-2 border text-center space-x-2">
                    <button
                      onClick={() => navigate(`/edit-unit/${u.id}`)}
                      className="px-2 py-1 bg-yellow-500 hover:bg-yellow-600 text-white rounded"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDelete(u.id)}
                      className="px-2 py-1 bg-red-600 hover:bg-red-700 text-white rounded"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
              {units.length === 0 && (
                <tr>
                  <td colSpan="6" className="px-4 py-6 border text-center text-gray-500">
                    لا توجد وحدات
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
